import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DrawingOverlayType } from 'src/app/modules/shared/enums/maps/drawingOverlayTypes.enum';

@Component({
    selector: 'app-drawing-manager',
    templateUrl: './drawing-manager.component.html',
    styleUrl: './drawing-manager.component.scss',
    standalone: false
})
export class DrawingManagerComponent implements OnInit {
  @Input() singleShapeMode: boolean = false;
  @Input() drawingModes: DrawingOverlayType[] = [];
  @Output() drawingModeChanged = new EventEmitter<DrawingOverlayType>();

  public drawingMode: DrawingOverlayType = null;

  private drawingManager: google.maps.drawing.DrawingManager;


  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

}
